import { APP_VERSION } from '../version';
import { Button, Card, Form, Input, Typography, App as AntdApp } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api/client';
import { useAuthStore, type CurrentUser } from '../stores/auth';

interface LoginFormValues {
  username: string;
  password: string;
}

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: CurrentUser;
}

export default function LoginPage() {
  const { message } = AntdApp.useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const setSession = useAuthStore((s) => s.setSession);

  const from = (location.state as { from?: Location })?.from?.pathname || '/';

  const onFinish = async (values: LoginFormValues) => {
    try {
      const resp = await api.post<LoginResponse>('/auth/login', values);
      setSession(resp.data);
      message.success(`欢迎，${resp.data.user.name}`);
      navigate(from, { replace: true });
    } catch (err: unknown) {
      const e = err as { response?: { data?: { message?: string } } };
      message.error(e.response?.data?.message || '登录失败');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1677ff 0%, #0958d9 100%)',
        position: 'relative',
      }}
    >
      <Card style={{ width: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Typography.Title level={3} style={{ marginBottom: 4 }}>
            DFRC 运营系统
          </Typography.Title>
          <Typography.Text type="secondary">合同与投标管理</Typography.Text>
        </div>
        <Form<LoginFormValues>
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="账号"
            name="username"
            rules={[{ required: true, message: '请输入账号' }]}
          >
            <Input prefix={<UserOutlined />} placeholder="请输入账号" />
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="请输入密码"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              登录
            </Button>
          </Form.Item>
          <Typography.Paragraph
            type="secondary"
            style={{ fontSize: 12, textAlign: 'center', marginBottom: 0 }}
          >
            账号由管理员发放，不开放自助注册
          </Typography.Paragraph>
        </Form>
      </Card>
      <div
        style={{
          position: 'absolute',
          bottom: 12,
          right: 16,
          fontSize: 11,
          color: 'rgba(255,255,255,0.45)',
          userSelect: 'text',
        }}
      >
        {APP_VERSION}
      </div>
    </div>
  );
}
